import { useCallback, useMemo } from "react";
import useApi from "../hooks/useApi";

export const useUserSensorReadingService = () => {
  const { get } = useApi();

  const getUserSensorReadings = useCallback(
    async (params = null) => {
      return await get(`/sensor-readings/user/all`, params);
    },
    [get]
  );

  const getSensorReadingById = useCallback(
    async (id, params = null) => {
      return await get(`/sensor-readings/${id}`, params);
    },
    [get]
  );

  return useMemo(
    () => ({
      getUserSensorReadings,
      getSensorReadingById,
    }),
    [getUserSensorReadings, getSensorReadingById]
  );
};